import Axios from "axios";

class FuncionarioAfastamentoTipoDataService {
  getAll() {
    return Axios.get("funcionarioAfastamentoTipos");
  }

  getDisponiveis() {
    return Axios.get("funcionarioAfastamentoTipos/disponiveis");
  }

  getDisponivelApp() {
    return Axios.get("funcionarioAfastamentoTipos/disponivel-app");
  }

  getOpcoesSupervisor() {
    return Axios.get("funcionarioAfastamentoTipos/opcoes-supervisor");
  }

  getPage(params) {
    return Axios.get("funcionarioAfastamentoTipos/page", { params });
  }

  create(params) {
    return Axios.post("funcionarioAfastamentoTipos", params);
  }

  update(params) {
    return Axios.put("funcionarioAfastamentoTipos/" + params.id, params);
  }

  find(id) {
    return Axios.get(`funcionarioAfastamentoTipos/${id}`);
  }

  delete(id) {
    return Axios.delete(`funcionarioAfastamentoTipos/${id}`);
  }

  replicate(params) {
    return Axios.put("funcionarioAfastamentoTipos/replicate", params);
  }
}

export default new FuncionarioAfastamentoTipoDataService();
